<div class="row">
  <div class="col-md-4 mt-10 pb-10" *ngFor="let supportCard of supportCards">
    <div class="card">
      <div class="inner-container">
        <div class="card-image-header show-image" style="background-image:url({{ supportCard.headImage }})"></div>
      </div>

      <div class="card-body">
        <h5 class="card-title" [ngStyle]="{ 'text-align': 'center' }">
          <a href="{{ supportCard.url }}">
            <i [class]="supportCard.headIconClass"></i>
            <br />
            {{ supportCard.cardTitle }}
          </a>
        </h5>

        <div [innerHtml]="returnHtmlFromRichText(supportCard.richTextBody)"></div>
      </div>

      <div class="button-center pb-30">
        <a 
          href="{{ supportCard.buttonUrl }}" 
          class="ba-btn sml" 
          (click)="handleButtonClick(supportCard.buttonText, supportCard.buttonUrl, $event)">
          {{ supportCard.buttonText }}
        </a>
      </div>
    </div>
  </div>
</div>
